import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces, colors } = getBaseTheme();

const ContractsContainerWrapper = styled.div`
    width: 100%;
    flex-grow: 1;
`;

const SearchBodyContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;

    div[class*='Search'] {
        width: 100%;
    }
`;

const InBodyTitle = styled(textblocks.Text)`
    margin-left: 0;
    ${texts.sizes.s};
`;

const CheckBoxContainer = styled.div`
    .square {
        position: static;
    }
`;

const CheckBoxWrapper = styled.div`
    margin-top: ${spaces.default.xxs};

    label {
        display: flex;
        align-items: center;
        font-family: Open Sans;

        div {
            width: 1.6rem;
            height: 1.6rem;
            margin-top: 2px;
            border-radius: 2px;
            box-sizing: border-box;

            :active {
                background-color: ${colors.notification.unread.backgroundColor};
            }
        }

        span {
            ${texts.sizes.xs};
        }
    }
`;

const ContractsListWrapper = styled.div`
    padding: ${spaces.inset.s};
`;

SearchBodyContainer.displayName = 'SearchBodyContainer';
InBodyTitle.displayName = 'InBodyTitle';

export {
    CheckBoxWrapper,
    InBodyTitle,
    SearchBodyContainer,
    ContractsContainerWrapper,
    CheckBoxContainer,
    ContractsListWrapper
};
